/* RAVIN / THE FIT LAB character continuity v1.
   UI only: no modification to size chart values, API endpoints, or fit calculations. */
(()=>{
 if(window.__RavinFitLabJourney2026)return;
 window.__RavinFitLabJourney2026=true;
 const h=v=>String(v??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
 const PATHS={
  women:{chest:'M 374 444 Q 550 481 694 446',waist:'M 429 566 Q 549 592 674 565',hips:'M 395 690 Q 571 725 726 671'},
  men:{chest:'M 338 657 Q 545 731 761 652',waist:'M 370 855 Q 556 897 738 845',hips:'M 334 1038 Q 567 1090 789 1020'}
 };
 const t=(overlay,en,ar)=>overlay.dir==='rtl'?ar:en;
 function productGender(root){
  const words=[root?.dataset.productType,root?.dataset.productTitle,root?.dataset.productHandle,
   root?.dataset.productTags,root?.dataset.productCollections].filter(Boolean).join(' ').toLowerCase();
  if(/(?:^|[^a-z])(women|womens|woman|female|ladies|girls|girl)(?:$|[^a-z])|حريمي|حريم|نسائي|بنات|سيدات/i.test(words))return 'women';
  if(/(?:^|[^a-z])(men|mens|man|male|boys|boy)(?:$|[^a-z])|رجالي|رجال|شباب/i.test(words))return 'men';
  return 'neutral';
 }
 function asset(root,gender){
  return gender==='women'?root?.dataset.rvFlFemaleAsset:
         gender==='men'?root?.dataset.rvFlMaleAsset:'';
 }
 function draw(root,gender,overlay,active='chest'){
  const src=asset(root,gender);
  if(!src||!PATHS[gender])return '';
  const desc=gender==='men'?
   t(overlay,'RAVIN male paper-bag character in swim shorts','شخصية ريفين بشورت سباحة لتوضيح مكان الخصر'):
   t(overlay,'RAVIN female paper-bag fashion character','شخصية ريفين الحريمي لتوضيح القياسات');
  return '<div class="rv-fl-brand-character__art" data-rv-brand-gender="'+gender+'" data-active-zone="'+active+'">'+
    '<img class="rv-fl-brand-character__photo" src="'+h(src)+'" alt="'+h(desc)+'" decoding="async" loading="lazy">'+
    '<svg class="rv-fl-brand-character__marks" viewBox="0 0 1122 1402" aria-hidden="true" preserveAspectRatio="xMidYMid meet">'+
    Object.entries(PATHS[gender]).map(([zone,path])=>
      '<path class="rv-fl-brand-character__mark" data-rv-zone="'+zone+'" d="'+path+'"/>').join('')+
    '</svg></div>';
 }
 function extendFitCharacters(overlay,root){
  if(overlay.dataset.rvFlView!=='fit'||overlay.dataset.rvFlChapter==='1')return;
  const figure=overlay.querySelector('.rv-fl-guided-character');
  if(!figure||figure.dataset.rvBrandCharacter==='true')return;
  const gender=productGender(root);
  const artwork=draw(root,gender,overlay,figure.dataset.activeZone||'chest');
  if(!artwork)return; // For unisex keep approved neutral default.
  const old=figure.querySelector(':scope > svg');
  if(!old)return;
  old.insertAdjacentHTML('beforebegin',artwork);old.remove();
  figure.dataset.rvBrandCharacter='true';
  figure.dataset.rvBrandGender=gender;
  figure.dataset.rvBrandStep=overlay.dataset.rvFlChapter;
 }
 function currentGuideGender(overlay,root){
  const selected=overlay.querySelector('[data-rv-fl-refgender][aria-pressed="true"]');
  if(selected&&['men','women'].includes(selected.dataset.rvFlRefgender))return selected.dataset.rvFlRefgender;
  return productGender(root);
 }
 function guide(overlay,root){
  if(overlay.dataset.rvFlView!=='guide')return;
  const content=overlay.querySelector('.rv-fl-exact-view,.rv-fl-generic-view');
  const heading=content?.querySelector('.rv-fl-guide-header');
  if(!heading)return;
  const gender=currentGuideGender(overlay,root);
  const illustration=draw(root,gender,overlay);
  const existing=content.querySelector('.rv-fl-guide-character');
  if(!illustration){existing?.remove();return}
  if(existing?.dataset.rvBrandGender===gender)return;
  if(existing)existing.remove();
  const card=document.createElement('section');
  card.className='rv-fl-guide-character';
  card.dataset.rvBrandGender=gender;
  card.setAttribute('aria-label',t(overlay,'Body measurement locations','أماكن قياس الجسم'));
  card.innerHTML='<div class="rv-fl-guide-character__visual">'+illustration+'</div>'+
    '<div class="rv-fl-guide-character__copy">'+
    '<span class="rv-fl-guide-character__eyebrow">RAVIN / THE FIT LAB</span>'+
    '<strong>'+h(t(overlay,'WHERE TO MEASURE','أماكن أخذ المقاسات'))+'</strong>'+
    '<p>'+h(t(overlay,'Body measurement points shown for guidance. Always follow the measurement definitions in the chart below.',
      'الرسمة بتوضح أماكن قياس الجسم. اتبع تعريفات القياسات الموضحة في الجدول اللي تحت.'))+'</p>'+
    '<div class="rv-fl-guide-character__zones" role="group" aria-label="'+
      h(t(overlay,'Measurement locations','أماكن القياسات'))+'">'+
    [['chest',t(overlay,'CHEST','الصدر')],['waist',t(overlay,'WAIST','الخصر')],['hips',t(overlay,'HIPS','الأرداف')]].map(([zone,label])=>
      '<button type="button" data-rv-brand-zone="'+zone+'" aria-pressed="'+(zone==='chest')+'">'+h(label)+'</button>').join('')+
    '</div></div>';
  heading.insertAdjacentElement('beforebegin',card);
  card.querySelectorAll('[data-rv-brand-zone]').forEach(btn=>btn.addEventListener('click',()=>{
    const zone=btn.dataset.rvBrandZone;
    card.querySelector('.rv-fl-brand-character__art')?.setAttribute('data-active-zone',zone);
    card.querySelectorAll('[data-rv-brand-zone]').forEach(b=>b.setAttribute('aria-pressed',String(b===btn)));
  }));
 }
 const hints={
  chest:['chest','bust','صدر','ثدي'],
  waist:['waist','خصر','وسط'],
  hips:['hip','buttock','أرداف','ارداف','ورك']
 };
 function instructionalZone(label,index){
  const value=String(label||'').toLowerCase();
  for(const [zone,match] of Object.entries(hints)){
   if(match.some(term=>value.includes(term)))return zone;
  }
  return ['chest','waist','hips'][index]||'';
 }
 function instructionalTabs(overlay,root){
  const panel=overlay.querySelector('.rv-fl-guided-help');
  // For exact garment charts use the original API-provided instructions as well.
  const area=panel||overlay.querySelector('.rv-fl-exact-view');
  if(!area)return;
  const tips=area.querySelector('.rv-fl-measure-tips');
  if(!tips||tips.dataset.rvBrandTabs==='true')return;
  const cards=[...tips.children].filter(x=>x.tagName==='DIV');
  // Only transform the expected three API instructions; preserve other source sets in full.
  if(cards.length!==3)return;
  // Preserve supplied titles and instructions; only their layout changes.
  const entries=cards.slice(0,3).map((node,i)=>({
   node,title:node.querySelector('strong')?.textContent?.trim()||'',zone:instructionalZone(node.querySelector('strong')?.textContent,i)
  }));
  if(new Set(entries.map(x=>x.zone)).size!==3)return; // Unexpected source: keep original instructions.
  const gender=productGender(root),image=draw(root,gender,overlay);
  const view=document.createElement('div');
  view.className='rv-fl-howto-tabs';
  view.innerHTML='<div class="rv-fl-howto-tabs__nav" role="group" aria-label="'+
   h(t(overlay,'Measurement guidance','إرشادات القياس'))+'">'+
   entries.map((item,i)=>'<button type="button" data-rv-howto-zone="'+item.zone+
     '" aria-pressed="'+(i===0)+'">'+h(item.title)+'</button>').join('')+'</div>'+
   '<div class="rv-fl-howto-tabs__body">'+
   (image?'<div class="rv-fl-howto-tabs__character">'+image+'</div>':'')+
   '<div class="rv-fl-howto-tabs__text" data-rv-howto-text></div></div>';
  tips.insertAdjacentElement('beforebegin',view);
  tips.dataset.rvBrandTabs='true';
  tips.classList.add('rv-fl-howto-source--hidden');
  const text=view.querySelector('[data-rv-howto-text]');
  function activate(zone){
   const match=entries.find(x=>x.zone===zone)||entries[0];
   text.replaceChildren(match.node.cloneNode(true));
   view.querySelector('.rv-fl-brand-character__art')?.setAttribute('data-active-zone',zone);
   view.querySelectorAll('[data-rv-howto-zone]').forEach(btn=>
      btn.setAttribute('aria-pressed',String(btn.dataset.rvHowtoZone===zone)));
  }
  view.querySelectorAll('[data-rv-howto-zone]').forEach(btn=>
    btn.addEventListener('click',()=>activate(btn.dataset.rvHowtoZone)));
  activate(entries[0].zone);
 }
 let queued=false;
 function synchronize(){
  queued=false;
  const overlay=document.querySelector('.rv-fl-overlay[data-open="true"]');
  const root=document.querySelector('[data-rv-fitlab]');
  if(!overlay||!root)return;
  extendFitCharacters(overlay,root);
  guide(overlay,root);
  instructionalTabs(overlay,root);
 }
 function schedule(){
  if(queued)return;queued=true;queueMicrotask(synchronize);
 }
 function initialize(){
  if(!document.body)return;
  const observer=new MutationObserver(schedule);
  observer.observe(document.body,{subtree:true,childList:true,attributes:true,
    attributeFilter:['data-open','data-rv-fl-view','data-rv-fl-chapter']});
  schedule();
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize,{once:true});
 else initialize();
})();